import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LocalFileImporterForm from '../forms/local-file-importer-form';
import { localFileImporterValidationSchema } from '../schema/local-file-importer.js';

export default function LocalFileImporterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Local File Importer Node Details',
        altText: 'Local File Importer Node',
        defaultLabel: 'Local File Importer Node',
      }}
    >
      <CommonNode
        FormComponent={LocalFileImporterForm}
        schemaResolver={localFileImporterValidationSchema}
      />
    </NodeProvider>
  );
}
